@use "../designer-tools/designer-tool-arrange/designer-tool-arrange.scss";

@include designer-tool-arrange.designer-tool-arrange();

gx-designer-view-container {
    &.no-pointer-events {
        pointer-events: none;
    }    
}

